
import LicenseInterface from '@/interfaces/License.interface';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { LicenseService } from './license.service';
import { ToastFactory } from '@/utils/ToastFactory';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import dayjs from 'dayjs';
import moment from 'moment';
const licenseService = new LicenseService();

export default defineComponent({
    name: 'AddLicense',
    data() {
        return {
            form:{
                license: {
                    active: true
                } as LicenseInterface,
            },
            computers: [],
            licenseId: "" as string,
            minDate: new Date(),
        };
    },

    setup(){
        return {
            v$: useVuelidate(),
        }
    },

    validations(){
        return {
            form: {
                license: {
                    licenseKey: { required },
                    licenseId: { required },
                    apiPassword: { required },
                    maxClientLicense: { required },
                    expiration: { required },
                    active: { required },
                }
            }
        }
    },

    computed: {
        ...mapGetters({
            storeLicenses: 'licenses/getLicense'
        })
    },

    methods: {
        async getLicenseById(){
            licenseService.getLicenseById(this.licenseId).then(() => {
                this.form.license = this.storeLicenses;
                this.form.license.expiration = this.storeLicenses.expiration ? dayjs(this.storeLicenses.expiration).format("DD/MM/YYYY") : "";
            })
        },

        async addNewLicense(data: LicenseInterface): Promise<void> {
            await licenseService.addLicense(data)
            .then(() => {
                this.$router.go(-1);
                this.$toast.add(ToastFactory.success(this.$t("toast.sucessLicense")));
            }).catch((e) => {
                console.log("error", e)
                this.$toast.add(ToastFactory.error(this.$t("toast.errorLicense")));
            })
        },

        async updateLicense(data: LicenseInterface): Promise<void> {
            await licenseService.updateLicense(this.licenseId, data)
            .then(() => {
                this.$router.go(-1);
                this.$toast.add(ToastFactory.success(this.$t("toast.sucessLicenseDelete")));
            }).catch((e) => {
                console.log("error", e)
                this.$toast.add(ToastFactory.error(this.$t("toast.errorLicenseDelete")));
            })
        },

        sendLicense(): void{
            this.form.license.expiration = moment(this.form.license.expiration, 'DD/MM/YYYY').toISOString();
            this.v$.form.$touch()
            if(!this.v$.form.$invalid){
                this.licenseId ? this.updateLicense(this.form.license) : this.addNewLicense(this.form.license);
            }
            
        },
    },

    mounted() {
        this.licenseId = this.$route?.params?.id as string;
        this.licenseId ? this.getLicenseById() : null;
    },
});
